import {Integration} from "../types"

export const INTEGRATIONS_DATA: Integration[] = [
  {
    id: "adp-workforce-now",
    name: "ADP Workforce Now",
    description: "Human capital management and payroll platform",
    enabled: false,
    types: ["HR & Directory"],
    icon: "IconBriefcase", // Using briefcase icon as fallback for HR platform
    color: "#C41E3A",
  },
  {
    id: "aircall",
    name: "AirCall.io",
    description: "Cloud-based call center and phone system",
    enabled: false,
    types: ["Call Center", "HR & Directory"],
    icon: "IconPhoneCall", // Using phone call icon as fallback
    color: "#00D4AA",
  },
  {
    id: "android-messages",
    name: "Android Messages",
    description: "Google's default messaging app for Android devices",
    enabled: false,
    types: ["Messaging"],
    icon: "IconBrandAndroid",
    color: "#3DDC84",
    comingSoon: true,
  },

  {
    id: "cloudtalk",
    name: "Cloudtalk.io",
    description: "Cloud contact center and business phone system",
    enabled: false,
    types: ["Call Center", "HR & Directory"],
    icon: "IconCloud", // Using cloud icon as fallback
    color: "#4A90E2",
  },

  {
    id: "dropbox",
    name: "Dropbox",
    description: "Cloud storage and file sharing platform",
    enabled: false,
    types: ["Storage", "Authentication", "HR & Directory"],
    icon: "IconBrandDropbox",
    color: "#0061FF",
  },

  {
    id: "gmail",
    name: "Gmail",
    description: "Google's email service",
    enabled: false,
    types: ["Messaging", "Authentication"],
    icon: "IconBrandGmail",
    color: "#EA4335",
  },

  {
    id: "google-drive",
    name: "Google Drive",
    description: "Cloud storage and collaboration platform by Google",
    enabled: false,
    types: ["Storage", "Authentication", "HR & Directory"],
    icon: "IconBrandGoogleDrive",
    color: "#4285F4",
  },
  {
    id: "google-workspace-directory",
    name: "Google Workspace Directory",
    description: "Google's cloud identity and directory management platform",
    enabled: false,
    types: ["HR & Directory", "Authentication"],
    icon: "IconBrandGoogle",
    color: "#4285F4",
  },

  {
    id: "imessage",
    name: "iMessage",
    description: "Apple's instant messaging service for iOS and macOS",
    enabled: false,
    types: ["Messaging"],
    icon: "IconBrandApple",
    color: "#007AFF",
    comingSoon: true,
  },
  {
    id: "imap",
    name: "IMAP",
    description: "Internet Message Access Protocol for email",
    enabled: false,
    types: ["Messaging"],
    icon: "IconMail",
    color: "#4285F4",
  },

  {
    id: "microsoft-active-directory",
    name: "Microsoft Active Directory / Entra ID",
    description: "Microsoft's identity and access management service",
    enabled: false,
    types: ["HR & Directory", "Authentication"],
    icon: "IconBrandAzure",
    color: "#0078D4",
  },
  {
    id: "microsoft-onedrive",
    name: "Microsoft OneDrive",
    description: "Microsoft's cloud storage and file sharing service",
    enabled: false,
    types: ["Storage", "Authentication"],
    icon: "IconBrandOnedrive",
    color: "#0078D4",
  },
  {
    id: "microsoft-outlook",
    name: "Microsoft Outlook",
    description: "Email and calendar service by Microsoft",
    enabled: true, // This is the only one enabled
    types: ["Authentication", "Messaging"],
    icon: "IconBrandOffice",
    color: "#0078D4",
  },
  {
    id: "microsoft-sharepoint",
    name: "Microsoft SharePoint",
    description: "Collaboration and document management platform",
    enabled: false,
    types: ["Storage", "Authentication"],
    icon: "IconShare", // Using share icon as fallback for SharePoint
    color: "#0078D4",
  },
  {
    id: "microsoft-teams",
    name: "Microsoft Teams",
    description: "Collaboration platform for chat, meetings, and files",
    enabled: false,
    types: ["Messaging", "Authentication", "HR & Directory"],
    icon: "IconBrandTeams",
    color: "#6264A7",
  },
  {
    id: "okta",
    name: "Okta",
    description: "Identity and access management platform",
    enabled: false,
    types: ["HR & Directory", "Authentication"],
    icon: "IconShield", // Using shield icon as fallback for security/identity platform
    color: "#007DC1",
  },
  {
    id: "ring-central",
    name: "Ring Central",
    description: "Cloud-based communications and collaboration solution",
    enabled: false,
    isNew: true,
    types: ["Call Center", "HR & Directory", "Messaging", "Authentication"],
    icon: "IconPhone",
    color: "#FF8800",
  },
  {
    id: "slack",
    name: "Slack",
    description: "Business communication platform",
    enabled: false,
    types: ["Messaging", "HR & Directory", "Authentication"],
    icon: "IconBrandSlack",
    color: "#4A154B",
  },
  {
    id: "webex",
    name: "Webex",
    description: "Video conferencing and collaboration platform",
    enabled: false,
    types: ["Messaging", "Authentication"],
    icon: "IconVideo",
    color: "#00BCF2",
  },
  {
    id: "zoom-phone",
    name: "Zoom Phone",
    description: "Cloud-based phone system and call center solution",
    enabled: false,
    isNew: true,
    types: ["Call Center", "HR & Directory", "Authentication"],
    icon: "IconBrandZoom", // Using brand zoom icon
    color: "#2D8CFF",
  },
]
